import { axiosPost } from '@/api/AxiosApi';
import { sendRequest, EndpointPayload } from '@/api/AxiosRequest';
import { CreateAdminWalletRequest } from '@/types/stake-db';

const BALANCE_API_URL = process.env.REACT_APP_BALANCE_API_URL;

// 관리자 지갑 등록
export const createAdminWallet = async (data: CreateAdminWalletRequest) => {
  const payload: EndpointPayload = {
    path: '/assetfi/admin/staking/wallets',
    body: data,
    apiUrl: BALANCE_API_URL,
    skipConvert: true,
  };

  return await sendRequest(payload, 'createAdminWallet', axiosPost);
};
